import css from './index.module.scss';
import { TweenMax, TimelineMax } from 'gsap';
import { useGlobal } from '@/utils/useGlobal';
import GsapA2 from './gsapA2';
import GsapA3 from './gsapA3';
import GsapA4 from './gsapA4';
import * as deviceDetect from 'react-device-detect';

const isSafari = deviceDetect.isSafari;

export default function AnimationA({}: any) {
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const { useEffect, useState } = useGlobal();
    const [gsapAniClassA, setGsapAniClassA] = useState(false);
    let gsapAniClassflag1 = false;

    useEffect(() => {
        const controller = new ScrollMagic.Controller();
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationA',
            offset: layoutH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '90%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        // 文字放大
        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: '.animationA',
            offset: 2 * layoutH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        // box 放大
        const tweenA1 = TweenMax.fromTo(
            '.animationA .gsapA2 .item-box1',
            1,
            {
                scale: 1,
                y: 0,
                x: 0,
                opacity: 1,
                ease: 'linear',
            },
            {
                scale: 1.2,
                y: -100,
                x: -100,
                opacity: 0,
                ease: 'linear',
            },
        );
        const tweenA2 = TweenMax.fromTo(
            '.animationA .gsapA2 .item-box2',
            1,
            {
                scale: 1,
                y: 0,
                x: 0,
                opacity: 1,
                ease: 'linear',
            },
            {
                scale: 1.2,
                y: -100,
                x: 100,
                opacity: 0,
                ease: 'linear',
            },
        );
        const tweenA3 = TweenMax.fromTo(
            '.animationA .gsapA2 .item-box3',
            1,
            {
                scale: 1,
                opacity: 1,
                ease: 'linear',
            },
            {
                scale: 1.2,
                opacity: 0,
                ease: 'linear',
            },
        );
        const tweenA4 = TweenMax.fromTo(
            '.animationA .gsapA2 .item-box4',
            1,
            {
                scale: 1,
                x: 0,
                opacity: 1,
                ease: 'linear',
            },
            {
                scale: 1.2,
                x: 100,
                opacity: 0,
                ease: 'linear',
            },
        );
        const tweenA5 = TweenMax.fromTo(
            '.animationA .gsapA2 .item-box5',
            1,
            {
                scale: 1,
                y: 0,
                x: 0,
                opacity: 1,
                ease: 'linear',
            },
            {
                scale: 1.2,
                y: 100,
                x: -100,
                opacity: 0,
                ease: 'linear',
            },
        );
        const tweenA6 = TweenMax.fromTo(
            '.animationA .gsapA2 .item-box6',
            1,
            {
                scale: 1,
                y: 0,
                x: 0,
                opacity: 1,
                ease: 'linear',
            },
            {
                scale: 1.2,
                y: 100,
                x: 100,
                opacity: 0,
                ease: 'linear',
            },
        );
        //文字放大
        const tweenA7 = TweenMax.fromTo(
            '.animationA .gsapA3',
            0.5,
            {
                scale: 0.5,
                opacity: 0,
                ease: 'linear',
            },
            {
                scale: 1,
                opacity: 1,
                ease: 'linear',
            },
        );
        const tweenA8 = TweenMax.fromTo(
            '.animationA .ef-scroll-ani-a1 .ef-scroll-ani-trigger',
            0.05,
            {
                opacity: 1,
                ease: 'linear',
            },
            {
                opacity: 0,
                ease: 'linear',
            },
        );
        const tweenA9 = TweenMax.fromTo(
            '.animationA .gsapA3 .msg-out-box',
            0.5,
            {
                fontSize: 36,
                ease: 'linear',
            },
            {
                fontSize: 80,
                ease: 'linear',
            },
        );
        const tweenA10 = TweenMax.fromTo(
            '.animationA .gsapA4 .img-box1',
            0.3,
            {
                opacity: 0,
                ease: 'linear',
            },
            {
                opacity: 0.8,
                ease: 'linear',
            },
        );
        sceneA2.on('progress', (self: any) => {
            const progress = self.progress;
            if (progress > 0 && !gsapAniClassflag1) {
                setGsapAniClassA(true);
                gsapAniClassflag1 = true;
            } else if (gsapAniClassflag1 && progress == 0) {
                setGsapAniClassA(false);
                gsapAniClassflag1 = false;
            }
        });

        const tweenA12 = TweenMax.to('.animationA .gsapA3', 0.2, {
            opacity: 0,
        });
        const tweenA13 = TweenMax.to('.animationA .gsapA4 .img-box1', 0.2, {
            opacity: 1,
        });
        const tweenA14 = TweenMax.to('.animationA .gsapA4 .msg-title1', 0.4, {
            opacity: 1,
            y: -60,
        });
        const tweenA15 = TweenMax.to('.animationA .gsapA4 .msg-title1', 0.2, {
            opacity: 0,
        });
        const tweenA16 = TweenMax.to('.animationA .gsapA4 .img-box1', 0.5, {
            opacity: 0.1,
        });
        const tweenA17 = TweenMax.to('.animationA .gsapA4 .msg-title2', 0.4, {
            opacity: 1,
            y: -60,
        });
        const tweenA18 = TweenMax.to('.animationA .gsapA4 .img-box2', 0.5, {
            opacity: 1,
        });

        const timelineA1 = new TimelineMax();
        const timelineA2 = new TimelineMax();
        timelineA1.add(tweenA1).add(tweenA2, 0).add(tweenA3, 0).add(tweenA4, 0).add(tweenA5, 0).add(tweenA6, 0).add(tweenA7, 0.5);
        timelineA2
            .add(tweenA8)
            .add(tweenA9, 0)
            .add(tweenA10, 0.2)
            .add(tweenA12, 0.5)
            .add(tweenA13, 0.5)
            .add(tweenA14, 0.5)
            .add(tweenA15, 1)
            .add(tweenA16, 0.8)
            .add(tweenA17, 1.2)
            .add(tweenA18, 0.8);

        sceneA1.setTween(timelineA1);
        sceneA2.setTween(timelineA2);

        controller.addScene(sceneA1);
        controller.addScene(sceneA2);
    }, []);

    return (
        <>
            <div className={`${css.animationA} animationA`}>
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani ef-scroll-ani-a1">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapA2 />
                            </div>
                        </div>
                    </div>

                    <div className={`ef-scroll-ani ef-scroll-ani-a2 ${gsapAniClassA && !isSafari ? 'showBgFont' : ''}`}>
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapA3 />
                            </div>
                        </div>
                    </div>

                    <div className="ef-scroll-ani ef-scroll-ani-a3">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapA4 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
